import { render, staticRenderFns } from "./SalesShipmentsPrintDeliveryNote.vue?vue&type=template&id=24145ce6&"
import script from "./SalesShipmentsPrintDeliveryNote.vue?vue&type=script&lang=js&"
export * from "./SalesShipmentsPrintDeliveryNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports